import request from '@/utils/request';

/**
 * 商城分类列表（树形）
 * POST sm/mall/category/list
 * body: categoryId, groupLevel, groupName, parentId, status(1-启用,0-禁用)
 */
export function getSamCategoryList(data) {
  return request({
    url: '/admin/sm/mall/category/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类状态切换
 * POST sm/mall/category/status
 * body: categoryId, status(1-启用,0-禁用)
 */
export function updateSamCategoryStatus(data) {
  return request({
    url: '/admin/sm/mall/category/status',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类同步全部
 * POST sm/mall/category/syncAll，无参数
 */
export function syncSamCategoryAll() {
  return request({
    url: '/admin/sm/mall/category/syncAll',
    method: 'POST'
  });
}

/**
 * 山姆分类调价
 * POST /admin/sm/mall/category/price-adjust
 * body: categoryId, categoryName, adjustRatio, remark
 */
export function smCategoryPriceAdjust(data) {
  return request({
    url: '/admin/sm/mall/category/price-adjust',
    method: 'POST',
    data: data
  });
}

/**
 * 山姆分类调价记录列表（分页）
 * POST /admin/sm/mall/category/price-adjust/records
 * body: categoryId, page, limit
 */
export function getSmPriceAdjustRecords(data) {
  return request({
    url: '/admin/sm/mall/category/price-adjust/records',
    method: 'POST',
    data: data
  });
}

/**
 * 删除山姆分类调价记录
 * DELETE /admin/sm/mall/category/price-adjust/{id}
 */
export function deleteSmPriceAdjustRecord(id) {
  return request({
    url: "/admin/sm/mall/category/price-adjust/".concat(id),
    method: 'DELETE'
  });
}